import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import { colors } from '../components/Colors'
import imgTeste from '../img/fenotipagem.jpg'
import imgMateriais from '../img/medicamentos-materiais.jpg'
import imgReanimacao from '../img/sala-de-reanimacao.jpg'
import iconEnfermagem from '../icons/icon-enfermagem.svg'
import iconBercario from '../icons/icon-bercario.svg'
import iconApartamento from '../icons/icon-apartamento.svg'
import iconExame from '../icons/medicamentos.svg'
import iconEquipamentos from '../icons/icon-equipamentos.svg'
import iconCentro from '../icons/icon-centro.svg'
import iconImportante from '../icons/icon-importante.svg'
import iconInternacao from '../icons/icon-internacao.svg'
import iconTipagem from '../icons/icon-tipagem.svg'
import iconOxigenio from '../icons/icon-oxigenio.svg'
import imgHonorarios from '../img/honorarios.jpg'
import imgcentralate from '../icons/centralate.svg'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import PageHeaderPlanos from '../components/PageHeaderPlanos'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import Anchor from '../components/Anchor'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  .center {
    max-width: 960px !important;
  }
`

const GroupContent = styled.section`
  padding: 2em 0;
  text-align: center;
  h2 {
    font-size: 2.5em;
    margin-bottom: 0px;
  }
  h3 {
    font-size: 1.2em;
    padding-bottom: 30px;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    font-family: 'Santral Light', Arial, Helvetica, sans-serif;
  }
  p.text {
    font-size: 0.8em;
    max-width: 726px;
    margin: 0 auto 2em;

    @media ${device.mobileL} {
      padding: 0 1em;
    }
  }
  @media ${device.mobileL} {
    padding: 1em;
  }
  .inner {
    display: flex;
    justify-content: space-between;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
  }
  .plano {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    img {
      width: 50%;
      max-height: 50%;
      margin: 10px;
      box-shadow: 1px 1px 10px #516d6e;
    }
    .imageBlock {
      :first-child {
        background-image: url(${imgHonorarios});
      }
      :last-child {
        background-image: url(${imgTeste});
      }
      background-repeat: no-repeat;
      background-size: cover;
      width: 50%;
      margin: 0.5em;
      min-height: 431px;
      box-shadow: 1px 1px 10px #516d6e;
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      @media ${device.mobileL} {
        width: 100%;
        min-height: 316px;
        background-position: 0 -33px;
        background-color: #ffffff;
      }
      div {
        width: 100%;
        padding-bottom: 2em;
      }
      h4 {
        color: #9394ca;
        padding-top: 5px;
        font-size: 1em;
        position: relative;
        width: 100%;
        margin: auto;
        :before {
          content: '';
          position: absolute;
          left: 44%;
          top: -10px;
          background: #9394ca;
          opacity: 0.5;
          height: 1px;
          width: 42px;
        }
      }
      p {
        width: 100%;
        font-size: 0.8em;
        margin: 0;
        position: relative;
        color: #4a4a4a;
        :after {
          content: '';
          position: absolute;
          left: 44%;
          bottom: -20px;
          background: #9394ca;
          height: 1px;
          width: 42px;
          opacity: 0.5;
        }
      }
    }

    .materiais {
      background-image: url(${imgMateriais});
      @media ${device.mobileL} {
        background-position: -330px 0;
      }
    }
    .reanimacao {
      background-image: url(${imgReanimacao});
      @media ${device.mobileL} {
        background-position: -526px 0;
      }
    }
    .imageBlock2 {
      min-height: 198px;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      margin: 0.5em;
      box-shadow: 1px 1px 10px #516d6e;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      div {
        width: 34%;
        padding-bottom: 3.2em;
        padding-right: 3.2em;
        @media ${device.mobileL} {
          width: 100%;
          padding: 3.2em;
        }
      }
      h4 {
        color: #9394ca;
        padding-top: 5px;
        font-size: 1em;
        position: relative;
        width: 100%;
        margin: auto;
        :before {
          content: '';
          position: absolute;
          left: 44%;
          top: -10px;
          background: #9394ca;
          opacity: 0.5;
          height: 1px;
          width: 42px;
        }
        :after {
          content: '';
          position: absolute;
          left: 44%;
          bottom: -15px;
          background: #9394ca;
          opacity: 0.5;
          height: 1px;
          width: 42px;
        }
      }
      p {
        width: 100%;
        font-size: 0.8em;
        margin: 0;
        position: relative;
        color: #4a4a4a;
        :after {
          content: '';
          position: absolute;
          left: 44%;
          bottom: -20px;
          background: #9394ca;
          height: 1px;
          width: 42px;
          opacity: 0.5;
        }
      }
    }
    .info {
      width: 50%;
      min-height: 100%;
      display: flex;
      flex-direction: column;
      @media ${device.mobileL} {
        width: 100%;
      }
    }
  }

  .last-info {
    .tel {
      a,
      span {
        color: #f4edc6;
        text-decoration: none;
      }
      a {
        padding-bottom: 20px;
        @media ${device.mobileL} {
          font-size: 0.8em;
        }
      }
      div {
        display: flex;
        justify-content: center;
      }
      p {
        margin: 1em;
        img {
          vertical-align: middle;
          margin-right: 2em;

          @media ${device.mobileL} {
            display: block;
            margin: auto auto 1em;
          }
        }
      }
    }
    .items {
      padding: 1em 0;
      margin-bottom: 2em;
      display: flex;
      border-bottom: 2px solid #f4edc6;
      @media ${device.mobileL} {
        flex-wrap: wrap;
      }
      .internacao {
        p {
          a {
            font-size: 18px;
          }
        }
      }
      div {
        margin-left: 4em;
        text-align: left;
        width: 50%;
        box-sizing: border-box;
        margin-right: 2em;
        @media ${device.mobileL} {
          width: 100%;
        }
        a {
          color: #ffffff;
          font-size: 0.8em;
        }
        h5 {
          position: relative;
          text-align: left;
          margin-bottom: 3em;
          img {
            vertical-align: middle;
            margin-right: 20px;
            position: absolute;
            top: 0;
            left: -70px;
          }
          :after {
            content: '';
            position: absolute;
            bottom: -20px;
            left: 0px;
            border-bottom: 1px solid #f4edc6;
            width: 30px;
          }
        }
      }
    }
  }

  .list {
    display: flex;
    padding: 0;
    justify-content: space-between;
    margin: 0;
    height: 100%;
    @media ${device.mobileL} {
      margin: 0;
    }
    h4 {
      color: #9394ca;
      margin-bottom: 0;
      padding-top: 5px;
      font-size: 1.5em;
      position: relative;
      :before {
        content: '';
        position: absolute;
        left: 39%;
        top: -10px;
        background: #9394ca;
        opacity: 0.5;
        height: 1px;
        width: 42px;
        @media ${device.mobileL} {
          content: none;
        }
      }
      @media ${device.mobileL} {
        margin: 0 0 5px 0;
        font-size: 1.2em;
      }
    }
    p {
      font-size: 1em !important;
      margin: 0;
      position: relative;
    }
    img {
      display: block;
      height: 45px;
      margin: 2em auto;
      box-shadow: none;
      @media ${device.mobileL} {
        margin: 2em auto;
      }
    }
    div {
      padding: 1em;
      width: 100%;
      background: #ffffff;
      color: #4a4a4a;
      margin: 10px;
      font-size: 0.6em;
      text-align: center;
      box-sizing: border-box;
      box-shadow: 1px 1px 10px #516d6e;
      @media ${device.mobileL} {
        width: 50%;
        margin: 10px;
        img {
          width: 30%;
        }
      }
    }
  }

  :nth-of-type(1) {
    background: ${colors.lilasGradiente2};
    color: #ffffff;
    h3 {
      color: #f4edc6;
      position: relative;
      padding-bottom: 1em;
      :after {
        content: '';
        position: absolute;
        bottom: 0px;
        width: 80px;
        background: #c4c5ea;
        height: 1px;
        right: 45%;
      }
    }
  }
`

export const PlanoMaternidadeTemplate = ({
  title,
  content,
  image,
  slug,
  area = 'Convênios',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <GroupContent>
          <Anchor id="plano-maternidade" />
          <div className="center">
            <h2>{parse(sessoes[0].tituloDaSessao)}</h2>
            <h3>{parse(sessoes[1].tituloDaSessao)}</h3>
            {parse(sessoes[1].texto)}
            <div className="plano">
              <div className="imageBlock">
                <div>
                  <h4>{parse(sessoes[2].tituloDaSessao)}</h4>
                  {parse(sessoes[2].texto)}
                </div>
              </div>
              <div className="info">
                <div className="list">
                  <div>
                    <img src={iconApartamento} alt="Armários" />
                    <h4>{parse(sessoes[3].tituloDaSessao)}</h4>
                    {parse(sessoes[3].texto)}
                  </div>
                  <div>
                    <img src={iconBercario} alt="Cama" />
                    <h4>{parse(sessoes[4].tituloDaSessao)}</h4>
                    {parse(sessoes[4].texto)}
                  </div>
                </div>
                <div className="list">
                  <div>
                    <img src={iconCentro} alt="Armários" />
                    <h4>{parse(sessoes[5].tituloDaSessao)}</h4>
                  </div>
                  <div>
                    <img src={iconOxigenio} alt="Cama" />
                    <h4>{parse(sessoes[6].tituloDaSessao)}</h4>
                    {parse(sessoes[6].texto)}
                  </div>
                </div>
              </div>
            </div>
            <div className="plano">
              <div className="imageBlock2 reanimacao">
                <div>{parse(sessoes[7].texto)}</div>
              </div>
            </div>
            <div className="plano">
              <div className="info">
                <div className="list">
                  <div>
                    <img src={iconEnfermagem} alt="Armários" />
                    <h4>{parse(sessoes[8].tituloDaSessao)}</h4>
                  </div>
                  <div>
                    <img src={iconEquipamentos} alt="Cama" />
                    <h4>{parse(sessoes[9].tituloDaSessao)}</h4>
                  </div>
                </div>
                <div className="list">
                  <div>
                    <img src={iconTipagem} alt="Armários" />
                    <h4>{parse(sessoes[10].tituloDaSessao)}</h4>
                  </div>
                  <div>
                    <img src={iconExame} alt="Cama" />
                    <h4>{parse(sessoes[11].tituloDaSessao)}</h4>
                  </div>
                </div>
              </div>
              <div className="imageBlock">
                <div>
                  <h4>{parse(sessoes[12].tituloDaSessao)}</h4>
                </div>
              </div>
            </div>
            <div className="last-info">
              <div className="items">
                <div>
                  <h5>
                    <img src={iconImportante} alt="Importante" />
                    {parse(sessoes[13].tituloDaSessao)}
                  </h5>
                  {parse(sessoes[13].texto)}
                </div>
                <div className="internacao">
                  <h5>
                    <img src={iconInternacao} alt="Internação" />
                    {parse(sessoes[14].tituloDaSessao)}
                  </h5>
                  {parse(sessoes[14].texto)}
                </div>
              </div>
              <div className="tel">
                <div>
                  <img src={imgcentralate} alt="Saiba mais" />
                  {parse(sessoes[15].texto)}
                </div>
                {parse(sessoes[16].texto)}
              </div>
            </div>
          </div>
        </GroupContent>
      </Container>
    </>
  )
}

PlanoMaternidadeTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const PlanoMaternidade = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <PlanoMaternidadeTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

PlanoMaternidade.propTypes = {
  data: PropTypes.object.isRequired,
}

export default PlanoMaternidade

export const PlanoMaternidadeQuery = graphql`
  query PlanoMaternidadeById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          texto
          tituloDaSessao
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
